import { LTime } from '@app/components/date/LTime';
import { Box, Typography } from '@mui/material';
import { ComponentProps, ReactNode } from 'react';

type StreamPopupHeaderProps = {
  icon: ReactNode;
  title?: ReactNode;
  time: ComponentProps<typeof LTime>['value'];
};

/**
 * Shared stream popup header with a domain icon, optional title, and timestamp.
 */
export function StreamPopupHeader({ icon, title, time }: StreamPopupHeaderProps) {
  return (
    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ display: 'flex', color: 'text.disabled', '& svg': { fontSize: 18 } }}>{icon}</Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        {title && (
          <>
            <Typography variant="caption" color="text.secondary">
              {title}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              ·
            </Typography>
          </>
        )}
        <Typography variant="caption" color="text.secondary">
          <LTime value={time} hour12={false} showSeconds />
        </Typography>
      </Box>
    </Box>
  );
}
